import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export type GameRoomStatus = 'live' | 'waiting' | 'closed';

export interface DashboardStats {
  totalUsers: number;
  todayUsers: number;
  todayUniqueCustomers: number; // ⭐ NEW: unique human players who played today

  totalGames: number;
  todayGames: number;
  gamesWithAi: number;
  gamesWithoutAi: number;
  gamesAiWon: number;
  todayGamesWithAi: number;
  todayGamesWithoutAi: number;
  todayGamesAiWon: number;

  // ⭐ Headline = real revenue (human in − human out)
  totalRevenue: number;
  todayRevenue: number;

  // ⭐ Informational breakdown
  totalRealStakeIn: number;
  todayRealStakeIn: number;
  totalRealPayoutOut: number;
  todayRealPayoutOut: number;

  usersRemainingBalance: number;
}

export interface RevenuePoint {
  day: string;
  fullDate: string;
  revenue: number;
}

export interface TrendPoint {
  day: string;
  fullDate: string;
  count: number;
}

export interface GameRoomItem {
  id: string;
  roomId: string;
  betAmount: number;
  playersCount: number;
  reservedCount: number;
  status: GameRoomStatus;
}

export interface DashboardData {
  stats: DashboardStats;
  revenueTrend: RevenuePoint[];
  gameTrend: TrendPoint[];
  userTrend: TrendPoint[];
  gameRooms: GameRoomItem[];
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class DashboardService {
  async getDashboardData(): Promise<DashboardData> {
    const response = await apiClient.get<ApiEnvelope<DashboardData>>(
      API_ENDPOINTS.DASHBOARD.GET_DATA
    );
    return response.data.data;
  }
}

const dashboardService = new DashboardService();
export default dashboardService;